import { EMPTY_OBJECT } from '../../../constants/common'
import { PROFILE_CONTACT_TYPE } from '../../../constants/contact'
import { EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE } from '../../Email'
import {
  UserProfileWidgetContacts,
  UserProfileWidgetCreated,
  UserProfileWidgetFinancialDetails,
  UserProfileWidgetOragCluster,
  UserProfileWidgetPartnerInfo,
  UserProfileWidgetPersonalInfo,
  UserProfileWidgetPostAddress,
} from '../../User'
import {
  isUserProfilePageAddNewActionPermitted,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION,
} from '../UserProfilePageHeaderFooter'

import { UserProfilePageWidgetKey } from './UserProfilePageWidgetList.constants'

export function getUserProfilePageWidgetListPermissions({
  canCreateEmails,
  userData,
}) {
  const permissions = userData?.permissions ?? EMPTY_OBJECT

  return {
    canEditContacts: permissions.can_edit_contacts,
    canEditInfo: permissions.can_edit_info,
    canSendEmail: userData
      ? isUserProfilePageAddNewActionPermitted({
          action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email,
          canCreateEmails,
          userData,
        })
      : false,
    canViewContacts: permissions.can_view_contacts,
    canViewInfo: permissions.can_view_info,
  }
}

export function getUserProfilePageWidgetListContactEmailType(contactType) {
  return contactType === PROFILE_CONTACT_TYPE.AUTH_EMAIL
    ? EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE.main
    : EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE.additional
}

export function getUserProfilePageWidgetListWidgetsByKey({
  canEditContacts,
  canEditInfo,
  canViewContacts,
  canViewCreated,
  canViewInfo,
  displayOragCluster,
  getContactsApi,
  info,
  isInfoSkeleton,
  isProfileLoading,
  options,
  profileId,
  userData,
  onClickContactEmail,
  onClickPartnerEmail,
  onSubmitInfo,
}) {
  const showInfoWidgets = isProfileLoading || canViewInfo

  return {
    [UserProfilePageWidgetKey.CONTACTS]: canViewContacts ? (
      <UserProfileWidgetContacts
        canEdit={canEditContacts}
        getApi={getContactsApi}
        profileId={profileId}
        onClickEmail={onClickContactEmail}
      />
    ) : null,
    [UserProfilePageWidgetKey.CREATED]: canViewCreated ? (
      <UserProfileWidgetCreated
        isSkeleton={isProfileLoading}
        userData={userData}
      />
    ) : null,
    [UserProfilePageWidgetKey.FINANCIAL_DETAILS]: showInfoWidgets ? (
      <UserProfileWidgetFinancialDetails
        canEdit={canEditInfo}
        data={info?.financial}
        isSkeleton={isInfoSkeleton}
        options={options}
        onSubmit={onSubmitInfo}
      />
    ) : null,
    [UserProfilePageWidgetKey.ORAG_CLUSTER]:
      showInfoWidgets && displayOragCluster ? (
        <UserProfileWidgetOragCluster
          canEdit={canEditInfo}
          data={info?.orag_cluster}
          isSkeleton={isInfoSkeleton}
          options={options}
          onSubmit={onSubmitInfo}
        />
      ) : null,
    [UserProfilePageWidgetKey.PARTNER_INFO]: showInfoWidgets ? (
      <UserProfileWidgetPartnerInfo
        canEdit={canEditInfo}
        data={info?.partner}
        isSkeleton={isInfoSkeleton}
        options={options}
        onClickEmail={onClickPartnerEmail}
        onSubmit={onSubmitInfo}
      />
    ) : null,
    [UserProfilePageWidgetKey.PERSONAL_INFO]: showInfoWidgets ? (
      <UserProfileWidgetPersonalInfo
        canEdit={canEditInfo}
        data={info?.personal}
        isSkeleton={isInfoSkeleton}
        options={options}
        onSubmit={onSubmitInfo}
      />
    ) : null,
    [UserProfilePageWidgetKey.POST_ADDRESS]: showInfoWidgets ? (
      <UserProfileWidgetPostAddress
        canEdit={canEditInfo}
        data={info?.address}
        isSkeleton={isInfoSkeleton}
        options={options}
        onSubmit={onSubmitInfo}
      />
    ) : null,
  }
}
